<template>
  <v-container>
    <v-card>
      <v-container>
        <h1 class="text-lg-center text-md-center text-sm-center earth-color">Volunteer Booking successful.</h1>
        <h4 class="text-lg-center text-md-center text-sm-center earth">Kindly check email for further details.</h4>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'success-volunteer',
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>
